// extracted by mini-css-extract-plugin
export default {"cls1":"VeloFab-StyledFab_cls1__Nj5n4","cls2":"VeloFab-StyledFab_cls2__Y6qzE VeloFab-StyledFab_cls1__Nj5n4","disabled":"VeloFab-StyledFab_disabled__Hiclt"};